import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Button = ({
  variant,
  className,
  padding,
  borderRadius,
  fontSize,
  fontWeight,
  backgroundColor,
  color,
  text,
  onClick,
  ...props
}) => {
  return variant === "text" ? (
    <TextButton
      className={className}
      onClick={onClick}
      color={color}
      fontSize={fontSize}
      {...props}
    >
      {text}
    </TextButton>
  ) : (
    <ContainedButton
      className={className}
      onClick={onClick}
      padding={padding}
      borderRadius={borderRadius}
      fontSize={fontSize}
      fontWeight={fontWeight}
      backgroundColor={backgroundColor}
      color={color}
      {...props}
    >
      {text}
    </ContainedButton>
  );
};

// styled
const TextButton = styled.button`
  border: none;
  background-color: inherit;
  cursor: pointer;
  display: inline-block;
  padding: 0;
  margin: 0;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
  color: ${(props) =>
    props.color ? props.color : props.theme.colors.textButtonColor};
`;

const ContainedButton = styled.button`
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : props.theme.colors.active};
  outline: none;
  border: ${(props) => (props.border ? props.border : "none")};
  flex: 1;
  color: ${(props) =>
    props.color ? props.color : props.theme.colors.background};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "18px")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "400")};

  &:hover {
    cursor: pointer;
  }
  &:disabled {
    background-color: ${(props) => props.theme.colors.disabled};
    color: ${(props) => props.theme.colors.disabledTextColor};
  }
  &.square {
    border-radius: ${(props) =>
      props.borderRadius ? props.borderRadius : "12px"};
    padding: ${(props) => (props.padding ? props.padding : "20px 32px")};
  }
  &.round {
    border-radius: ${(props) =>
      props.borderRadius ? props.borderRadius : "24px"};
    padding: ${(props) => (props.padding ? props.padding : "16px 24px")};
  }
`;

Button.propTypes = {
  variant: PropTypes.oneOf(["text", "contained"]).isRequired,
  className: PropTypes.string,
  padding: PropTypes.string,
  borderRadius: PropTypes.string,
  fontSize: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default Button;
